import { BlockType, StaticField } from '@/lib/types';

export const FIELD_TYPES = [
  {
    id: BlockType.Text,
    name: 'Text',
    description: 'A single line of text.',
  },
  {
    id: BlockType.Numeric,
    name: 'Numeric',
    description: 'A numeric field allowing any number to be entered. This is an unformatted field.',
  },
  {
    id: BlockType.Date,
    name: 'Date & Time',
    description: 'A picker that allows selection of a date and optional time.',
  },
  {
    id: BlockType.Selection,
    name: 'Select List',
    description: 'A list of options to be selected from.',
  },
  {
    id: BlockType.Checkbox,
    name: 'Checkbox',
    description: 'A checkbox field.',
  },
  {
    id: BlockType.LongText,
    name: 'Text Editor',
    description: 'A text editor for longer text.',
  },
  {
    id: BlockType.Media,
    name: 'Media',
    description: 'Upload an image or a video.',
  },
  {
    id: BlockType.Section,
    name: 'Section',
    description: 'A section block.',
  },
  {
    id: BlockType.Link,
    name: 'Link',
    description: 'A link field.',
  },
];

export const STATIC_FIELDS = [
  StaticField.Name,
  StaticField.Description,
  StaticField.Media,
  StaticField.IsPublic,
  StaticField.CreatedDate,
  StaticField.UpdatedDate,
];
